import type { GeometryResult, RoomInput } from './types';

export function calculateGeometry(room: RoomInput): GeometryResult {
  const perimeter = 2 * (room.length + room.width);
  const rawWallArea = perimeter * room.height;
  const openingsArea = room.doors * 1.8 + room.windows * 1.5;
  const wallArea = Math.max(0, rawWallArea - openingsArea);
  const ceilingArea = room.length * room.width;
  const skirtingLength = Math.max(0, perimeter - room.doors * 0.9);

  return {
    perimeter,
    rawWallArea,
    openingsArea,
    wallArea,
    ceilingArea,
    skirtingLength
  };
}
